import React, { Component } from 'react'
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
  Button, Input, Spinner,
} from 'reactstrap'
import oikosApi from '../../services/oikos'
import { notifyError, notifySuccess } from '../../utils/notify'

class DeleteRecordByAdmin extends Component {
  constructor(props) {
    super(props)
    this.state = {
      deleteRecordPassword: '',
      deleteRecordIsLoading: false,
    }
  }

  handleSubmit = async () => {
    try {
      this.setState({ deleteRecordIsLoading: true })

      const { recordId, recordType, toggle } = this.props

      const body = {
        action: 'delete',
        table: recordType,
        data: {
          [`${recordType}_id`]: recordId,
        },
      }
      console.tron.log('body handleRemoveRecordSubmit', body)

      const res = await oikosApi.post('/', body)
      console.tron.log('res handleRemoveRecordSubmit', res)

      notifySuccess('Registro removido com sucesso.')

      this.setState({
        deleteRecordIsLoading: false,
        deleteRecordPassword: '',
      })

      toggle()
    } catch (e) {
      notifyError('Erro ao excluir registro.')
      console.tron.log('Erro ao excluir registro.', e)
      this.setState({ deleteRecordIsLoading: false, deleteRecordPassword: '' })
    }
  }

  render() {
    const { deleteRecordPassword, deleteRecordIsLoading } = this.state
    const { toggle, isOpen, recordName } = this.props

    return (
      <Modal
        centered
        isOpen={isOpen}
      >
        <ModalHeader>
          {`Excluir registro: ${recordName}`}
        </ModalHeader>
        <ModalBody>
          <p>Deseja mesmo excluir este registro? Esta ação não poderá ser revertida.</p>

          <p>Digite a senha de administrador para confirmar.</p>

          <Input
            type="password"
            className="mt-3"
            value={deleteRecordPassword}
            onChange={(e) => this.setState({ deleteRecordPassword: e?.target?.value })}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            color="light"
            disabled={deleteRecordIsLoading}
            onClick={() => {
              this.setState({ deleteRecordPassword: '' })

              toggle()
            }}
          >
            Cancelar
          </Button>

          <Button
            className="ml-2"
            color="danger"
            onClick={() => this.handleSubmit()}
            disabled={
              deleteRecordIsLoading
              || deleteRecordPassword !== process.env.REACT_APP_ADMIN_PASSWORD
            }
          >
            {deleteRecordIsLoading && (
              <Spinner size="sm" className="mr-2" />
            )}
            Excluir
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default DeleteRecordByAdmin
